// Full searchable radio details from the supplied 2023 statewide channel plan.
export default String.raw`36.1|152.1500|151.4|158.6100|151.4|H|N|
36.2|152.2400|151.4|158.7000|151.4|H|N|
36.3|152.5400|151.4|157.8000|151.4|H|N|
36.4|152.5700|151.4|157.8300|151.4|H|N|
36.5|152.7800|151.4|158.0400|151.4|H|N|
36.6|153.8300|151.4|153.8300|151.4|H|N|
36.7|153.8900|151.4|153.8900|151.4|H|N|
36.8|154.0700|151.4|154.0700|151.4|H|N|
36.9|154.3400|CSQ|154.3400|151.4|H|N|
36.10|154.4150|151.4|154.4150|151.4|H|N|
36.11|154.4300|CSQ|154.4300|151.4|H|N|
36.12|158.9700|151.4|158.9700|151.4|H|N|
36.13|159.0900|151.4|159.0900|151.4|H|N|
36.14|154.3925|D152|154.3925|D152|L|N|
36.15|154.4000|151.4|154.4000|151.4|H|N|
36.16|159.6300|151.4|159.6300|151.4|H|N|
36.17|159.5250|151.4|159.5250|151.4|H|N|
36.18|161.3700|151.4|161.3700|151.4|H|N|
36.19|161.4750|151.4|161.4750|151.4|H|N|
36.20|161.5050|151.4|159.6000|151.4|H|N|
36.21|161.5200|151.4|159.1050|151.4|H|N|
36.22|172.3750|CSQ|164.9375|OST|H|N|
36.23|173.7750|CSQ|164.8750|OST|H|N|
36.24|171.5000|CSQ|164.8250|OST|H|N|
36.25|156.0750|156.7|156.0750|156.7|H|N|
36.26|158.8050|D703|158.8050|D703|H|N|
36.27|154.1300|D703|154.1300|D703|H|N|
36.28|155.3250|156.7|155.3250|156.7|H|N|LA Area Fire Chiefs Association Tac
36.29|155.4000|156.7|155.4000|156.7|H|N|LA Area Fire Chiefs Association Tac
36.30|150.7750|156.7|150.7750|156.7|H|N|LA Area Fire Chiefs Association Tac
36.31|155.3550|156.7|155.3550|156.7|H|N|LA Area Fire Chiefs Association Tac
36.32|170.0125|CSQ|165.2500|OST|L|N|
36.33|170.4125|CSQ|165.9625|OST|L|N|
36.34|170.6875|CSQ|166.5750|OST|L|N|
36.35|173.0375|CSQ|167.3250|OST|L|N|
36.36|162.9875|$293|170.3500|$293|H|N|Digital
36.37|172.3375|D263|167.3500|D263|H|N|
36.38|173.5500|$653|163.1625|$653|H|N|Digital
36.39|172.4125|$653|162.8875|$653|H|N|Digital
36.40|173.6000|$653|164.1875|$653|H|N|Digital
36.41|159.1800|CSQ|155.5200|OST|H|N|LA Regional Tactical Comms System
36.42|159.0300|100.0|155.5800|100.0|H|N|LA Regional Tactical Comms System
36.43|159.1500|100.0|155.3700|100.0|H|N|LA Regional Tactical Comms System
36.44|154.8300|100.0|154.8300|100.0|H|N|
36.45|153.9500|D132|156.1950|D132|H|N|
36.46|153.9200|D155|158.9400|D155|H|N|
36.47|151.1600|D134|159.3750|D134|H|N|
36.48|153.7700|D143|155.9250|D143|H|N|
36.49|150.7750|D152|150.7750|D152|H|N|
36.50|153.8300|131.8|153.8300|131.8|H|N|
36.51|151.2350|D226|151.2350|D226|H|N|
36.52|153.8000|D243|153.8000|D243|H|N|
36.53|153.8150|D244|153.8150|D244|H|N|
36.54|154.3550|D703|154.3550|D703|H|N|
36.55|155.6100|D703|155.6100|D703|H|N|
36.56|154.1600|CSQ|159.1950|OST|H|N|
36.57|154.2200|CSQ|159.1950|131.8|H|N|
36.58|151.0850|136.5|159.0000|136.5|H|N|
36.59|154.1300|107.2|155.9850|D156|H|N|
36.60|151.1375|156.7|151.1375|156.7|L|N|
36.61|154.4525|156.7|154.4525|156.7|L|N|
36.62|158.7375|156.7|158.7375|156.7|L|N|
36.63|159.4725|156.7|159.4725|156.7|L|N|
36.64|154.2800|156.7|154.2800|156.7|H|N|
36.65|154.2650|156.7|154.2650|156.7|L|N|
36.66|154.2950|156.7|154.2950|156.7|L|N|
36.67|154.2725|156.7|154.2725|156.7|L|N|
36.68|154.2875|156.7|154.2875|156.7|L|N|
36.69|154.3025|156.7|154.3025|156.7|L|N|
36.70|155.3400|156.7|155.3400|156.7|H|N|
36.71|155.3475|156.7|155.3475|156.7|H|N|
36.72|155.1600|CSQ|155.1600|OST|H|N|
36.73|159.0150|156.7|159.0150|156.7|H|N|
36.74|155.7150|156.7|155.7150|156.7|H|N|
36.75|154.3100|156.7|154.3100|156.7|H|N|
36.76|156.1650|156.7|156.1650|156.7|H|N|
36.77|154.2350|74.4|154.2350|74.4|H|N|
36.78|154.3850|79.7|154.3850|79.7|H|N|
36.79|153.8900|136.5|153.8900|136.5|H|N|
36.80|154.1750|123.0|154.1750|123.0|H|N|
36.81|155.2950|97.4|155.2950|97.4|H|N|
36.82|153.9950|136.5|153.9950|136.5|H|N|
36.83|154.3700|CSQ|158.9550|103.5|H|N|
36.84|154.0550|94.8|154.0550|94.8|H|N|
36.85|154.1450|103.5|154.1450|103.5|H|N|
36.86|154.4450|136.5|154.4450|136.5|H|N|
36.87|156.3300|156.7|156.3300|156.7|H|N|
36.88|154.2050|$601|154.7400|$601|H|N|
36.89|154.2500|$601|159.1650|$601|H|N|
36.90|168.6250|000.0|168.6250|110.9|L|N|Emergency
37.1|153.77000|110.9|154.25000|136.5|H|N|
37.2|153.90500|110.9|154.99500|127.3|H|N|
37.3|153.98000|110.9|155.71500|127.3|H|N|
37.4|156.13500|100.0|154.95000|114.8|H|N|
37.5|154.87500|100.0|155.13000|114.8|H|N|
37.6|150.99500|100.0|154.80000|114.8|H|N|
37.7|155.59500|100.0|155.59500|100.0|L|N|
37.8|154.84500|100.0|154.84500|100.0|L|N|
37.9|154.65000|100.0|154.65000|100.0|L|N|
37.10|155.64000|100.0|155.64000|100.0|L|N|
37.11|153.83000|100.0|153.83000|100.0|L|N|
37.12|154.19000|100.0|154.19000|100.0|L|N|
37.13|155.97000|100.0|155.97000|100.0|L|N|
37.14|151.19000|192.8|151.19000|192.8|L|N|
37.15|151.44500|192.8|151.44500|192.8|L|N|
37.16|156.07500|156.7|156.07500|156.7|H|N|
37.17|151.22000|192.8|151.22000|192.8|L|N|
37.18|159.26250|192.8|159.26250|192.8|L|N|
37.19|159.36750|192.8|159.36750|192.8|L|N|
37.20|167.47500|000.0|167.47500|000.0|L|N|
37.21|151.35500|103.5|159.30000|000.0|H|N|
37.22|154.35500|127.3|159.03000|127.3|H|N|
37.23|154.72500|127.3|159.09000|127.3|H|N|
37.24|154.40000|127.3|159.06000|127.3|H|N|
37.25|155.10000|127.3|159.16500|127.3|H|N|
37.26|150.79000|000.0|150.79000|000.0|L|N|
37.27|154.35500|100.0|150.77500|100.0|H|N|
37.28|151.37750|100.0|156.04500|100.0|H|N|
37.29|151.49000|123.0|155.25750|123.0|H|N|
37.30|153.83000|123.0|153.83000|123.0|L|N|
37.31|155.08500|100.0|155.08500|100.0|L|N|
37.32|154.19000|100.0|154.19000|100.0|L|N|
37.33|154.44500|82.5|155.77500|88.5|H|N|
37.34|154.31000|82.5|159.04500|88.5|H|N|
37.35|154.04000|82.5|156.00000|88.5|H|N|
37.36|154.19000|100.0|154.19000|100.0|L|N|
37.37|154.43000|127.3|158.95500|127.3|H|N|
37.38|154.07000|85.4|158.91000|85.4|H|N|
37.39|155.88000|85.4|158.88000|85.4|L|N|
37.40|154.40000|127.3|159.06000|127.3|H|N|
37.41|155.10000|127.3|159.16500|127.3|H|N|
37.42|168.62500|000.0|168.62500|110.9|L|N|Emergency
38.1|155.05500|82.5|155.05500|82.5|H|N|
38.2|154.32500|79.7|155.83500|79.7|H|N|
38.3|153.95000|167.9|153.95000|167.9|L|N|
38.4|153.87500|85.4|158.80500|85.4|H|N|
38.5|154.02500|167.9|154.02500|167.9|L|N|
38.6|155.98500|186.2|154.72500|186.2|H|N|
38.7|153.83000|167.9|153.83000|167.9|L|N|
38.8|154.41500|100.0|155.73000|000.0|H|N|
38.9|156.03000|123.0|156.03000|123.0|L|N|
38.10|154.41500|100.0|155.73000|131.8|H|N|Oxnard Plains Command
38.11|153.89000|107.2|153.89000|107.2|L|N|
38.12|154.07000|123.0|154.07000|123.0|L|N|
38.13|154.01000|100.0|155.73000|100.0|H|N|Lockwood Valley East
38.14|151.01000|192.8|155.25000|192.8|H|N|Lockwood Valley West
38.15|154.23500|167.9|154.23500|167.9|L|N|
38.16|154.20500|100.0|154.20500|100.0|H|N|
38.17|151.35500|103.5|159.30000|000.0|H|N|No Sites in Ventura Co
38.18|151.26500|103.5|159.33000|000.0|H|N|Tone 4/South Mtn
38.19|151.32500|103.5|159.31500|000.0|H|N|Tone 7/South, Tone8/Sisar
38.20|151.22000|192.8|151.22000|192.8|L|N|
38.21|159.26250|192.8|159.26250|192.8|L|N|
38.22|159.36750|192.8|159.36750|192.8|L|N|
38.23|168.62500|000.0|168.62500|110.9|L|N|Emergency
39.1|151.35500|103.5|159.30000|OST|H|N|
39.2|151.34000|103.5|159.34500|OST|H|N|
39.3|151.33250|131.8|159.27750|OST|H|N|
39.4|151.17500|110.9|159.28500|OST|H|N|
39.5|171.42500|103.5|164.80000|OST|H|N|
39.6|154.17500|103.5|158.86500|103.5|H|N|
39.7|150.61250|000.0|167.45000|OST|H|N|
39.8|151.01000|123.0|154.96500|123.0|H|N|
39.9|154.26500|156.7|154.26500|156.7|L|N|
39.10|154.29500|156.7|154.29500|156.7|L|N|
39.11|151.37000|192.8|151.37000|192.8|L|N|
39.12|168.20000|000.0|168.20000|OST|L|N|
39.13|169.11250|000.0|169.11250|OST|L|N|
39.14|168.48750|000.0|168.48750|OST|L|N|
39.15|151.22000|192.8|151.22000|192.8|L|N|
39.16|159.26250|192.8|159.26250|192.8|L|N|
39.17|153.81500|000.0|151.10000|OST|H|N|
39.18|151.26500|103.5|159.33000|000.0|H|N|
39.19|168.62500|000.0|168.62500|110.9|L|N|Emergency
40.1|136.0000|0.0|136.0000|.0.0|H|N|`;
